import moment from 'moment';
import map from 'lodash/map';
import lodash from 'lodash';
window.lodash = lodash;
window.moment = moment;

Date.prototype.getWeek = function () {
    let date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    // console.log('w1---', week1)

    let week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

Date.prototype.isSameDateAs = function (pDate) {
    return (
        this.getFullYear() === pDate.getFullYear() &&
        this.getMonth() === pDate.getMonth() &&
        this.getDate() === pDate.getDate()
    );
};

const StoriesChartDataTransformer = {

    getDateRangeOfWeek: (weekNo, year, startDate, endDate) => {

        const d1 = StoriesChartDataTransformer.getDateOfWeek(weekNo, year);
        // console.log("d1----",d1)
        const rangeIsFrom = `${eval(d1.getMonth() + 1)}/${d1.getDate()}/${d1.getFullYear()}`;
        // console.log(d1.getMonth() + 1);
        d1.setDate(d1.getDate() + 6);

        // console.log(d1.setDate(d1.getDate() + 6))

        const rangeIsTo = `${eval(d1.getMonth() + 1)}/${d1.getDate()}/${d1.getFullYear()}`;
        // console.log(rangeIsFrom, rangeIsTo)
        // const startDateWeekNumber = moment(startDate).week();

        return `${rangeIsFrom} to ${rangeIsTo}`;

    },

    getDateOfWeek: (w, y) => {
        let d = (1 + (w - 1) * 7);
        // console.log("d---", d, '---w---',w, '----y---',y,"---date---", new Date(y, 0, d-1))
        return new Date(y, 0, d-1);
    },

    getDateOfWeekAndYear: (weekNo, year) => {
        let d1 = StoriesChartDataTransformer.getDateOfWeek(weekNo, year);
        // console.log("54 ---", d1)
        return d1;
    },

    transform: (usersData, metricesMap, searchObject) => {
        // console.log(searchObject)/
        let startDateWeekNumber = moment(searchObject.startDate).isoWeek();
        // console.log(searchObject.startDate,"-----transform----",startDateWeekNumber)
        let startDateWeekYear = moment(searchObject.startDate).year();

        const tempStartYear = startDateWeekYear;

        // let endDateWeekNumber = new Date(searchObject.endDate).getWeek();

        let endDateWeekNumber = moment(searchObject.endDate).isoWeek();


        const colors = ['#1EC4B4', '#F06292', '#5099DE', '#F2994A', '#BB6BD9', '#4E5E7C', '#874B60', '#FF0000', '#33FF00'];

        const endDateWeekYear = moment(searchObject.endDate).year();


        const startMonth = new Date(searchObject.startDate).getMonth();

        const endMonth = new Date(searchObject.endDate).getMonth();

        const weekNumbers = [];

        const weekYears = [];

        while (startDateWeekYear <= endDateWeekYear) {
            weekYears.push(startDateWeekYear++);
        }

        let firstYear = weekYears[0];
        while (firstYear <= weekYears[weekYears.length - 1]) {
            if (startDateWeekNumber === 53) {
                startDateWeekNumber = 1;
            }

            if (startDateWeekNumber === endDateWeekNumber && firstYear === endDateWeekYear && startMonth !== endMonth) {
                endDateWeekNumber = 53;
            }

            if (firstYear === weekYears[weekYears.length - 1]) {
                while (startDateWeekNumber <= endDateWeekNumber) {
                    weekNumbers.push({
                        week: startDateWeekNumber,
                        year: firstYear,
                    });
                    startDateWeekNumber++;
                }
            } else {
                while (startDateWeekNumber <= 52) {
                    weekNumbers.push({
                        week: startDateWeekNumber,
                        year: firstYear,
                    });
                    startDateWeekNumber++;
                }
            }
            firstYear++;
        }
        let counter = -1;
        const LineChartData = usersData ? map(metricesMap, (d, i) => {
            // console.log(usersData, weekNumbers)
            counter++;
            const xData = [];
            const yData = [];
            const textData = [];
            let rollingValue=[] 
            for (const week of weekNumbers) {
                // console.log("week----", we/ek)
                const rangeValue = StoriesChartDataTransformer.getDateOfWeekAndYear(week.week, week.year);
                // console.log(rangeValue, rangeValue.toISOString())
                xData.push(rangeValue);

                const tempArray = [];

                for (const item of usersData) {
                    // console.log(
                    //         item.name, moment(new Date(item.createdDate)).week(), '--1--',
                    //         moment(item.createdDate).week(),  '--2--',moment(item.createdDate).isoWeek(),
                    //         '----',new Date(item.createdDate)
                    //         )
                    if (moment(item.createdDate).isoWeek() === week.week && item.year === week.year) {
                        // tempArray.push(item);
                        // console.log(week, '-------',item)
                        // console.log(item)
                        rollingValue.push(item)
                    }
                }
                // console.log('weekkk-----', rollingValue)
                // yData.push(tempArray.length);
                yData.push(rollingValue.length)
                textData.push(`Date: ${StoriesChartDataTransformer.getDateRangeOfWeek(week.week, week.year, searchObject.startDate, searchObject.endDate)} count : ${rollingValue.length}`);
            }

            return {
                x: xData,
                y: yData,
                type: 'line',
                line: colors[counter],
                marker: {
                    color: colors[counter],
                    symbol: metricesMap[0].symbol,
                },
                name: metricesMap[0].name,
                text: textData,
                hoverinfo: 'text',
                showlegend: true,
            };
        }) : null;
        return LineChartData;
    },
};

export default StoriesChartDataTransformer;
